import React, { useEffect } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import {
  dashboard_lecture_1,
  dashboard_lecture_2,
  dashboard_lecture_3,
  btn_slide_prev,
  btn_slide_next,
} from 'components/base/images';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { color } from 'styles/utils';
import IconButton from '@material-ui/core/IconButton';

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <img src={btn_slide_prev} />
      {/* <ChevronLeftIcon fontSize="large" /> */}
    </div>
  );
}

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <img src={btn_slide_next} />
      {/* <ChevronRightIcon fontSize="large" /> */}
    </div>
  );
}

// const sliderList = [
//   {
//     contentUrl: dashboard_lecture_1,
//     linkUrl: 'https://www.youtube.com/watch?v=9OmwQd9hU-8',
//   },
//   {
//     contentUrl: dashboard_lecture_2,
//     linkUrl: 'https://www.youtube.com/watch?v=a-jbn_JCElI',
//   },
//   {
//     contentUrl: dashboard_lecture_3,
//     linkUrl: 'https://www.youtube.com/watch?v=aInttHr0j_Q',
//   },
//   {
//     contentUrl: dashboard_lecture_3,
//     linkUrl: 'https://www.youtube.com/watch?v=aInttHr0j_Q',
//   },
// ];

const ImagePopupSlick = ({ data, winH, winW, fileIdx }) => {
  const { ipcRenderer } = window;
  // TODO: 실제 url 및 이미지 연동
  const settings = {
    // dots: true,
    infinite: true,
    // infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // focusOnSelect: true,
    // swipeToSlide: false,
    // swipe: false,
    // centerMode: true,
    initialSlide: Number(fileIdx),
    // initialSlide: 2,
    // arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  useEffect(() => {
    console.log('fileIdx _________', fileIdx);
  }, [fileIdx]);
  const test = () => {
    console.log('11111111111111111111111111111111');
    if (!ipcRenderer) return;
    ipcRenderer.send('showProjectChatViewer', {});
  };

  if (!data?.length) return null;
  return (
    <Styled.ImagePopupSlick
      data-component-name="ImagePopupSlick"
      {...settings}
      winH={winH}
      winW={winW}
    >
      {data.map((item, idx) => (
        <div className="imagePopupSlick__item_box" key={idx}>
          <div className="imagePopupSlick__item_title_box">
            <div className="imagePopupSlick__item_title">{item.originName}</div>
          </div>
          <div className="imagePopupSlick__item_image_box">
            <div
              className="imagePopupSlick__item_image"
              style={{
                backgroundImage: `url(${item.cloudDirectory})`,
              }}
            ></div>
          </div>
        </div>
      ))}
    </Styled.ImagePopupSlick>
  );
};

const Styled = {
  ImagePopupSlick: styled(Slider)`
    width: 100%;
    height: 100%;
    /* padding: 40px 55px 0 55px; */

    .imagePopupSlick__item_box {
      /* display: block; */
      /* width: 496px; */
      /* width: calc(100% - 110px); */
      /* margin: 0 auto; */
      padding: 40px 55px 0 55px;
      /* padding: 40px 0 0 0; */
      /* margin: 0 55px; */
      width: ${({ winW }) => winW - 110 + 'px'};
      height: ${({ winH }) => winH - 80 + 'px'};
      position: relative;
      .imagePopupSlick__item_title_box {
        position: absolute;
        top: 0;
        left: 0;
        height: 40px;
        width: 100%;
        display: flex;
        align-items: center;
        .imagePopupSlick__item_title {
          padding-left: 10px;
          font-size: 12px;
          font-weight: 500;
          color: #444;
          width: ${({ winW }) => winW + 'px'};
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .imagePopupSlick__item_image_box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: inherit;
        height: inherit;
        .imagePopupSlick__item_image {
          background-size: contain;
          width: 100%;
          height: 100%;
          background-repeat: no-repeat;
          background-position: center center;
        }
      }
    }

    .slick-arrow {
      display: flex !important;
      align-items: center;
      justify-content: center;
      z-index: 1;
      /* width: 50px;
      height: 40px;
      border-radius: 50%; */
      width: 50px;
      height: 88px;
      padding: 0;
      border-radius: 0;
      &:hover {
        background-color: #000;
        opacity: 0.2;
      }

      &.slick-prev {
        left: 0px;
        /* svg {
          margin-left: -3px;
        } */
      }
      &.slick-next {
        right: 0px;
        /* svg {
          margin-right: -3px;
        } */
      }
      &:before,
      &:after {
        display: none;
      }
    }
    /* .slick-arrow:before,
    .slick-arrow:after {
      content: '';
    } */
  `,
};

export default React.memo(ImagePopupSlick);
